import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import moment from 'moment';
import tinycolor2 from 'tinycolor2';
import { MessageContent } from './messageContent';
import NIcon from '../../brand/icon/icon.vue';
import NAvatar from '../avatar/avatar.vue';
import { Message, TextMessage } from './message';
import { MessageStatus } from './messageStatus';
import { computed, PropType } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'text-message',
  props: {
  outboundMessageColour: {
    type: String,
    default: '#062b80',
  },
  message: {
    type: Object as PropType<TextMessage>,
    required: true,
  },
  displayAvatar: {
    type: Boolean,
    default: false,
  },
  enableAvatarTooltip: {
    type: Boolean,
    default: false,
  },
  tooltipPosition: {
    type: String as PropType<'right' | 'left'>,
    default: 'right',
  },
},
  setup(__props) {

const props = __props;

const formattedMessage = computed(() => {
  return new MessageContent(props.message.text as string).EscapeHtml().ProcessUrls().NewLinesToBreaks().Value;
});

function getMessageTimestamp(timestamp: Date): string {
  return moment(timestamp).format('HH:mm');
}

function isRead(m: Message) {
  return m.status === MessageStatus.Read;
}

function shouldShowTickIcon(m: Message) {
  switch (m.status) {
    case MessageStatus.DeliverySucceeded:
    case MessageStatus.Read:
    case MessageStatus.Received:
    case MessageStatus.Sent:
      return true;
    default:
      return false;
  }
}

function shouldShowAlertIcon(m: Message) {
  return m.status === MessageStatus.DeliveryFailed;
}

function getMessageStyle() {
  let backgroundColour = '#f5f5f5';
  let textColour = '#212121';

  if (props.message.direction === 'outbound') {
    backgroundColour = props.outboundMessageColour;
    textColour = tinycolor2(backgroundColour).isDark() ? '#fff' : '#212121';
  }

  if (props.message.status === MessageStatus.DeliveryFailed) {
    backgroundColour = '#ffdada';
    textColour = '#212121';
  }

  return {
    background: backgroundColour,
    color: textColour,
  };
}

return (_ctx: any,_cache: any) => {
  const _component_n_tooltip = _resolveComponent("n-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["n-text-message", {
      'n-text-message--right': __props.tooltipPosition === 'left',
      'n-text-message--left': __props.tooltipPosition === 'right',
    }])
  }, [
    (__props.displayAvatar)
      ? (_openBlock(), _createBlock(NAvatar, {
          key: 0,
          name: __props.message.name,
          "image-url": __props.message.avatarUrl,
          "enable-tooltip": __props.enableAvatarTooltip,
          size: "s",
          class: _normalizeClass(["n-text-message__avatar", {
        'n-text-message__avatar--left': __props.tooltipPosition === 'right',
        'n-text-message__avatar--right': __props.tooltipPosition === 'left',
      }])
        }, null, 8, ["name", "image-url", "enable-tooltip", "class"]))
      : _createCommentVNode("", true),
    _createVNode(_component_n_tooltip, { position: __props.tooltipPosition }, {
      default: _withCtx(() => [
        _createElementVNode("span", {
          style: _normalizeStyle(getMessageStyle()),
          class: "msg-text",
          innerHTML: formattedMessage.value
        }, null, 12, _hoisted_1)
      ]),
      message: _withCtx(() => [
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(getMessageTimestamp(__props.message.timestampUtc)) + " ", 1),
          (shouldShowAlertIcon(__props.message))
            ? (_openBlock(), _createBlock(NIcon, {
                key: 0,
                icon: "alert",
                fill: "#ff6348"
              }))
            : _createCommentVNode("", true),
          (shouldShowTickIcon(__props.message))
            ? (_openBlock(), _createBlock(NIcon, {
                key: 1,
                icon: "tick",
                fill: isRead(__props.message) ? '#57d272' : '#bdbdbd'
              }, null, 8, ["fill"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["position"])
  ], 2))
}
}

})